import React, {useRef, useState} from 'react';
import {DocumentEditorContainerComponent, Toolbar} from '@syncfusion/ej2-react-documenteditor';
import {enableRtl} from '@syncfusion/ej2-base';
import {DocumentEditorContainerModel} from '@syncfusion/ej2-documenteditor';
import {DefaultHtmlAttributes} from '@syncfusion/ej2-react-base';
import classnames from 'classnames';
import {Button} from 'react-bootstrap';
import {SplashScreen} from '../../../../../_metronic/_partials/controls';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-documenteditor/styles/material.css';
import styles from './syncfusion.module.scss';

interface DocxEditorProps extends DocumentEditorContainerModel, DefaultHtmlAttributes {
  file: Blob | File | string;
  onSave?: (file: Blob) => void;
  className?: string;
}

enableRtl(true);
DocumentEditorContainerComponent.Inject(Toolbar);

const DocxEditorSyncFusion = ({file, onSave, className, restrictEditing, ...rest}: DocxEditorProps) => {
  const [loading, setLoading] = useState(true);
  const viewer = useRef<DocumentEditorContainerComponent>(null);

  const init = async () => {
    await openFile();
  };

  const openFile = async () => {
    if (viewer.current) {
      viewer.current.documentEditor.open(file as string);
      setLoading(false);
    }
  };

  const save = async () => {
    if (viewer.current) {
      setLoading(true);
      const file = await viewer.current.documentEditor.saveAsBlob('Docx');
      if (onSave) {
        onSave(file);
      }
      setTimeout(() => {
        setLoading(false);
      }, 1500)
    }
  };

  return (
    <div className="position-relative w-100 h-100">
      {loading &&
        <div className="position-absolute top-0 bottom-0 right-0 left-0 m-auto zindex-5"><SplashScreen/></div>}
      <div className={classnames(styles.editorContainer, className)}>
        <div id="default_title_bar" className={classnames('e-de-ctn-title', styles.topbar)}>
          {!restrictEditing && (
            <Button variant="link" className={styles.button} onClick={save} disabled={loading}>
              <img src={toAbsoluteUrl('/media/common/Save-white.svg')} alt="save"/>
              <span>Save</span>
            </Button>
          )}
        </div>
        <DocumentEditorContainerComponent
          id="container"
          height={'60vh'}
          serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/documenteditor/"
          enableToolbar={true}
          ref={viewer}
          created={init}
          restrictEditing={restrictEditing || false}
          {...rest}
        />
      </div>
    </div>
  );
};

export default DocxEditorSyncFusion;